export default __webpack_public_path__ + "static/media/pj-mercado-livre-rn-firebase.0f05459f.png";